import { getConfig as p } from "../../../shared/data/configuration/state/index2.js";
import "@ado/base-service";
import "@ado/location-library";
import "@ado/cookie-library";
import { getCsr as u } from "../../../shared/data/csr/state/index2.js";
import "../../../shared/data/layout/state/index.js";
import { FooterStyle as l } from "../../../shared/data/layout/state/index3.js";
import { getLocation as r } from "../../../shared/data/location/state/index.js";
import "../../../shared/data/navigation/state/index2.js";
import "@ado/experiment-library";
import "../../../search/state/index2.js";
import "../../../shared/data/user/state/index2.js";
import "@ado/acs-standard-library";
import f from "./index3.js";
import { DisclaimerSettings as y } from "../types/index.js";
import { defineComponent as v, computed as t, ref as C, watch as d } from "vue";
import { PhoneContactInfo as g } from "../types/index4.js";
import { generateColumnLinks as L } from "../types/index5.js";
const V = v({
  name: "FooterVuexWrapper",
  components: {
    Footer: f
  },
  props: {
    footerStyle: {
      type: String,
      default: l.Normal
    }
  },
  setup() {
    const o = t(() => p().values), m = t(
      () => new g(u().number, u().hours)
    ), e = t(() => r().currentCountry), c = t(() => new y(
      o.value.footerCopyrightText,
      o.value.showDisclaimerLink,
      o.value.sitebrandtm,
      e.value.countryCode,
      o.value.disclaimerURL,
      o.value.termsURL,
      o.value.cookiesPolicyURL,
      o.value.privacyPolicy
    )), s = t(() => ({
      currentCountry: r().currentCountry,
      countries: r().countries,
      majorCountries: r().countries.filter((n) => n.isMajorCountry)
    })), i = C([]);
    d(
      () => o.value,
      (n) => {
        i.value = L(
          n,
          e.value.countryCode
        );
      },
      { immediate: !0 }
    );
    const a = t(
      () => Object.keys(o.value).length === 0 || e.value.countryCode === void 0
    );
    return {
      disclaimerSettings: c,
      footerLinks: i,
      notLoaded: a,
      countrySelectorSettings: s,
      csr: m,
      config: o
    };
  }
});
export {
  V as default
};
//# sourceMappingURL=index2.js.map
